// Bespoke customizer: bag → monogram → hardware → review, with a live
// crystal-monogram preview rendered over the bag photo. One state object
// drives every rendered surface (PDP summary, modal steps, both preview
// instances). See snippets/bespoke-data.liquid for the crystal/letter-style/
// hardware data this reads, and snippets/bespoke-modal.liquid for the markup.
(function () {
  const root = document.querySelector('[data-lv-bespoke]');
  if (!root) return;

  let uiReady = false;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ data ---- */
  const dataEl = root.querySelector('[data-bespoke-data]');
  let DATA = { crystals: [], letterStyles: [], hardware: [] };
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    /* leave DATA empty; nothing renders without it */
  }

  const [defX, defY, defW, defH] = (root.dataset.bespokeEngraveDefault || '53,55,66,42')
    .split(',')
    .map(Number);

  const defRot = Number(root.dataset.bespokeEngraveRotate) || 0;
  const HOLD_CHARS = Number(root.dataset.bespokeHoldChars) || 0;

  // Estimated delivery: a range counted forward from the shopper's date (e.g. 42 to 56 days).
  const DELIVERY_MIN = Number(root.dataset.bespokeDeliveryMin) || 0;
  const DELIVERY_MAX = Math.max(Number(root.dataset.bespokeDeliveryMax) || 0, DELIVERY_MIN);
  function deliveryRange() {
    if (!DELIVERY_MAX) return '';
    const day = (n) => {
      const d = new Date();
      d.setHours(12, 0, 0, 0);
      d.setDate(d.getDate() + n);
      return d;
    };
    const a = day(DELIVERY_MIN);
    const b = day(DELIVERY_MAX);
    const md = { month: 'short', day: 'numeric' };
    const full = { month: 'short', day: 'numeric', year: 'numeric' };
    const fmt = (d, o) => d.toLocaleDateString('en-US', o);
    if (a.getFullYear() !== b.getFullYear()) return `${fmt(a, full)} – ${fmt(b, full)}`;
    if (a.getMonth() === b.getMonth()) return `${fmt(a, md)} – ${b.getDate()}, ${b.getFullYear()}`;
    return `${fmt(a, md)} – ${fmt(b, full)}`;
  }
  const DELIVERY_TEXT = deliveryRange();
  if (DELIVERY_TEXT) {
    document.querySelectorAll('[data-lv-delivery]').forEach((el) => {
      el.textContent = DELIVERY_TEXT;
    });
    document.querySelectorAll('[data-lv-delivery-prop]').forEach((input) => {
      input.value = DELIVERY_TEXT;
    });
  }
  const HOLD_CAP = 0.9; // widest the text may get, as a share of the bag photo width
  const FIXED_STYLE = root.dataset.bespokeFixedStyle || '';
  const FIXED_CRYSTAL = root.dataset.bespokeFixedCrystal || '';
  // Single-bag products (Baseball): no Bag/Hardware steps; Personalize → Review.
  const SOLO = root.dataset.bespokeSolo === 'true';
  // Customers may upload a signature instead of typing text.
  const ALLOW_UPLOAD = root.dataset.bespokeUpload === 'true';
  // Printed-label products (Champagne Bottle): instead of crystal monogram
  // text, a few small ink lines are drawn at fixed spots on the photo.
  // Each row: Label|center X %|center Y %|max width %|height %|max chars|placeholder|case|view|tilt degrees|mask (date)
  const LABEL_LINES = (root.dataset.bespokeLabelLines || '')
    .split('\n')
    .map((row) => row.trim())
    .filter(Boolean)
    .map((row) => {
      const [label, x, y, w, h, max, placeholder, cs, view, rot, mask] = row.split('|').map((t) => t.trim());
      return {
        label,
        x: Number(x) / 100,
        y: Number(y) / 100,
        w: Number(w) / 100,
        h: Number(h) / 100,
        max: Number(max) || 14,
        placeholder: placeholder || '',
        upper: (cs || 'upper') !== 'none',
        view: Number(view) === 1 ? 1 : 0,
        rot: Number(rot) || 0,
        mask: mask || '',
      };
    })
    .map((l) => ({ ...l, noDraw: !(l.w > 0 && l.h > 0) }))
    .filter((l) => l.label && Number.isFinite(l.x) && Number.isFinite(l.y));
  const LABEL = LABEL_LINES.length > 0;
  const LABEL_INK = root.dataset.bespokeLabelInk || '#512b11';
  const LABEL_STYLE_ID = root.dataset.bespokeLabelStyle || '';
  const LABEL_CRYSTAL_ID = root.dataset.bespokeLabelCrystal || '';
  // Signature-only products (Black Card) skip the Type/Upload switch.
  const UPLOAD_ONLY = root.dataset.bespokeUploadOnly === 'true';
  // Optional paid add-on (MLB: pick a team, optionally add initials for +$500).
  const ADDON = root.dataset.bespokeAddon === 'true';
  // Request-note variant (MLB Cap): the add-on step is a free, optional text note instead of paid initials.
  const NOTE = ADDON && root.dataset.bespokeRequestNote === 'true';
  // Paid request (MLB Cap): same note box, but behind a "+$500 Add customization" choice
  // that charges the add-on product as its own cart line (needs an add-on product).
  const PAID_NOTE = NOTE && !!root.dataset.bespokeAddonVariant;
  const ADDON_PRICE = NOTE && !PAID_NOTE ? 0 : Number(root.dataset.bespokeAddonPrice) || 500;
  const ADDON_MAX = NOTE ? 300 : Number(root.dataset.bespokeAddonMax) || 3;
  // Full customization add-on (MLB Baseball): once chosen, the same type-or-upload-a-signature
  // personalization as the plain Baseball, previewed on a blank photo, for a flat fee.
  const CUSTOM = ADDON && ALLOW_UPLOAD && !NOTE;
  const ADDON_NOUN = root.dataset.bespokeAddonNoun || 'Initials';
  const PLACEHOLDER_OVERRIDE = root.dataset.bespokePlaceholder || '';
  const CUSTOM_IMG = root.dataset.bespokeCustomImage || '';
  const ADDON_VARIANT = root.dataset.bespokeAddonVariant || '';
  const BASE_PRICE_TEXT = root.dataset.bespokePrice;
  // Pick-a-variant products with no lettering (NFL Football), optionally grouped by the first option (Color).
  const NO_TEXT = root.dataset.bespokeNopers === 'true';
  const GROUPED = root.dataset.bespokeGroups === 'true';

  const bagEls = Array.from(root.querySelectorAll('[data-lv-bespoke-bag]'));
  const BAGS = bagEls.map((el) => {
    const engraveCsv = el.dataset.lvBespokeEngrave;
    const engrave = engraveCsv
      ? (() => {
          const [x, y, w, h, r] = engraveCsv.split(',').map(Number);
          return { x: x / 100, y: y / 100, w: w / 100, h: h / 100, rot: Number.isFinite(r) ? r : defRot };
        })()
      : { x: defX / 100, y: defY / 100, w: defW / 100, h: defH / 100, rot: defRot };
    return {
      value: el.dataset.lvBespokeBag,
      el,
      variantId: el.dataset.lvBespokeVariantId,
      variantIdChampagne: el.dataset.lvBespokeVariantIdChampagne || '',
      impliesHardware: el.dataset.lvBespokeImpliesHardware || '',
      images: {
        silver: el.dataset.lvBespokeImageSilver,
        champagne: el.dataset.lvBespokeImageChampagne,
        back: el.dataset.lvBespokeImageBack || '',
      },
      price: (Number(el.dataset.lvBespokePrice) || 0) / 100,
      group: el.dataset.lvBespokeGroup || '',
      label: el.dataset.lvBespokeLabel || el.dataset.lvBespokeBag,
      allowed: (el.dataset.lvBespokeAllowed || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean),
      engrave,
    };
  });

  if (!BAGS.length || !DATA.crystals.length) return;

  // Solo flow (one Personalize step): the bag and letter-color pickers show
  // inside it only when there is actually a choice to make.
  const SOLO_BAGS = SOLO && BAGS.length > 1;
  const SOLO_COLOR = SOLO && !FIXED_CRYSTAL;

  /* --------------------------------------------------------- color math -- */
  function hexToRgb(hex) {
    const v = hex.replace('#', '');
    const n = parseInt(v.length === 3 ? v.replace(/(.)/g, '$1$1') : v, 16);
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  }
  function rgbToHex(r, g, b) {
    const c = (n) => Math.max(0, Math.min(255, Math.round(n))).toString(16).padStart(2, '0');
    return `#${c(r)}${c(g)}${c(b)}`;
  }
  function mix(hexA, hexB, t) {
    const a = hexToRgb(hexA);
    const b = hexToRgb(hexB);
    return rgbToHex(a.r + (b.r - a.r) * t, a.g + (b.g - a.g) * t, a.b + (b.b - a.b) * t);
  }
  /** Derive a 4-stop tone ramp from one real production hex so the pavé
      texture and gem swatches have light/dark variation to render with. */
  function deriveTone(hex) {
    return {
      light: mix(hex, '#ffffff', 0.55),
      base: hex,
      dark: mix(hex, '#000000', 0.4),
      deep: mix(hex, '#000000', 0.62),
    };
  }

  const CRYSTALS = DATA.crystals.map((c) => ({ ...c, tone: deriveTone(c.hex) }));
  const crystalById = (id) => CRYSTALS.find((c) => c.id === id) || CRYSTALS[0];
  const styleById = (id) => DATA.letterStyles.find((s) => s.id === id) || DATA.letterStyles[0];
  const hardwareById = (id) => DATA.hardware.find((h) => h.id === id) || DATA.hardware[0];

  /* ---------------------------------------------------- crystal texture -- */
  const textureCache = new Map();
  function hashString(s) {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }
  function seededRandom(seed) {
    let s = seed || 1;
    return () => {
      s = (Math.imul(s, 1664525) + 1013904223) >>> 0;
      return s / 4294967296;
    };
  }
  /* Stone-set text fill. The letters are filled with a generated pavé of round
     stones that is (1) drawn at the real stone pitch of the bag photo and at the
     screen's pixel density, so it neither looks blurry nor scaled wrong, (2) a
     seamless tile with per-stone variation and slow light/dark drift, so no
     repeat is visible, and (3) colour-calibrated: its average colour and contrast
     match the photographed bag in that crystal colour (PHOTO_TONES, measured from
     the hi-res bag photos) instead of a darkened web-style gradient. */
  const PHOTO_TONES = {
    crystal: ['#edebe7', 0.12],
    prosecco: ['#eac99d', 0.14],
    aurum: ['#eebd57', 0.16],
    jet: ['#16171a', 0.5],
    hematite: ['#5d6264', 0.4],
    'light-siam': ['#d61b2d', 0.26],
    fire: ['#d61b2d', 0.26],
    fuchsia: ['#d65192', 0.28],
    'light-rose': ['#eb8fb5', 0.2],
    'purple-velvet': ['#884256', 0.4],
    'dark-indigo': ['#2a2d52', 0.45],
    'light-sapphire': ['#bad4e7', 0.12],
    'leaf-green': ['#4f8762', 0.34],
    emerald: ['#4f8762', 0.34],
  };
  const GEM_COLS = 26;
  const GEM_ROWS = 30;
  const gemCache = new Map();
  const STONE_PITCH = (Number(root.dataset.bespokeStonePitch) || 0.9) / 100;
  const lumOf = (rgb) => 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
  function photoToneOf(crystal) {
    const t = PHOTO_TONES[crystal.id];
    return t ? { hex: t[0], cov: t[1] } : { hex: crystal.hex, cov: 0.3 };
  }
  // Returns { url, w, h } (w/h in CSS px) for a crystal at a stone pitch given in CSS px.
  function getGemTexture(crystal, pitchCss) {
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const P = Math.max(4, Math.min(28, Math.round(pitchCss * dpr)));
    const key = `${crystal.id}|${P}|${dpr}`;
    const hit = gemCache.get(key);
    if (hit) return hit;
    const W = GEM_COLS * P;
    const rowH = P * 0.866;
    const H = Math.round(GEM_ROWS * rowH);
    const rh = H / GEM_ROWS;
    const cv = document.createElement('canvas');
    cv.width = W;
    cv.height = H;
    const ctx = cv.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    const rnd = seededRandom(hashString(crystal.id + 'gem'));
    const wrap = (x, y, draw) => {
      for (const dx of [-W, 0, W]) for (const dy of [-H, 0, H]) draw(x + dx, y + dy);
    };
    const gray = (v, a = 1) => `rgba(${Math.round(v * 255)},${Math.round(v * 255)},${Math.round(v * 255)},${a})`;
    ctx.fillStyle = gray(0.14);
    ctx.fillRect(0, 0, W, H);
    // slow drift in brightness that is periodic over the tile (no seam, no obvious repeat)
    const ph = [rnd() * 6.28, rnd() * 6.28, rnd() * 6.28];
    const drift = (x, y) =>
      1 +
      0.07 * Math.sin((x / W) * 6.2832 * 2 + ph[0]) * Math.cos((y / H) * 6.2832 * 3 + ph[1]) +
      0.05 * Math.sin((x / W) * 6.2832 * 5 + (y / H) * 6.2832 * 4 + ph[2]);
    for (let row = 0; row < GEM_ROWS; row++) {
      for (let col = 0; col < GEM_COLS; col++) {
        const cx0 = (col + (row % 2 ? 0.5 : 0)) * P + P / 2;
        const cy0 = row * rh + rh / 2;
        const x = cx0 + (rnd() - 0.5) * P * 0.1;
        const y = cy0 + (rnd() - 0.5) * P * 0.1;
        const r = P * (0.46 + rnd() * 0.035);
        const b = Math.max(0.6, Math.min(1.15, (0.9 + (rnd() - 0.5) * 0.3) * drift(x, y)));
        wrap(x, y, (wx, wy) => {
          const g = ctx.createRadialGradient(wx - r * 0.3, wy - r * 0.34, r * 0.05, wx, wy, r);
          g.addColorStop(0, gray(Math.min(1, 0.95 * b)));
          g.addColorStop(0.45, gray(0.74 * b));
          g.addColorStop(0.8, gray(0.5 * b));
          g.addColorStop(1, gray(0.28 * b));
          ctx.fillStyle = g;
          ctx.beginPath();
          ctx.arc(wx, wy, r, 0, Math.PI * 2);
          ctx.fill();
        });
        // facet glint: every stone catches a little light, a few catch a lot
        const hot = rnd();
        const ga = hot > 0.9 ? 0.95 : 0.25 + rnd() * 0.45;
        const gr = r * (hot > 0.9 ? 0.34 : 0.2 + rnd() * 0.1);
        const ox = -r * (0.18 + rnd() * 0.25);
        const oy = -r * (0.2 + rnd() * 0.25);
        wrap(x, y, (wx, wy) => {
          ctx.fillStyle = gray(1, ga);
          ctx.beginPath();
          ctx.arc(wx + ox, wy + oy, gr, 0, Math.PI * 2);
          ctx.fill();
        });
      }
    }
    // colourise: keep the stone shading, take the hue/level from the photographed colour
    const { hex, cov } = photoToneOf(crystal);
    const target = hexToRgb(hex);
    const img = ctx.getImageData(0, 0, W, H);
    const d = img.data;
    let gm = 0;
    for (let i = 0; i < d.length; i += 4) gm += d[i];
    gm /= d.length / 4;
    let gv = 0;
    for (let i = 0; i < d.length; i += 4) gv += ((d[i] / gm) - 1) ** 2;
    const sm = Math.sqrt(gv / (d.length / 4)) || 1;
    const k = Math.min(1.8, (cov * 1.3) / sm);
    const px = d.length / 4;
    const out = new Float32Array(px * 3);
    for (let i = 0; i < px; i++) {
      const g = d[i * 4];
      const m = Math.max(0.05, 1 + k * (g / gm - 1));
      const hl = Math.pow(Math.max(0, (g - 205) / 50), 1.4);
      const lift = hl * (lumOf(target) < 90 ? 0.6 : 0.4);
      out[i * 3] = Math.min(255, target.r * m);
      out[i * 3 + 1] = Math.min(255, target.g * m);
      out[i * 3 + 2] = Math.min(255, target.b * m);
      out[i * 3] += (255 - out[i * 3]) * lift;
      out[i * 3 + 1] += (255 - out[i * 3 + 1]) * lift;
      out[i * 3 + 2] += (255 - out[i * 3 + 2]) * lift;
    }
    // pull the average back onto the photographed colour (highlights and clamping shift it)
    for (let pass = 0; pass < 3; pass++) {
      const mean = [0, 0, 0];
      for (let i = 0; i < px; i++) for (let c = 0; c < 3; c++) mean[c] += out[i * 3 + c];
      const f = [target.r / (mean[0] / px || 1), target.g / (mean[1] / px || 1), target.b / (mean[2] / px || 1)];
      for (let i = 0; i < px; i++) for (let c = 0; c < 3; c++) out[i * 3 + c] = Math.min(255, out[i * 3 + c] * f[c]);
    }
    for (let i = 0; i < px; i++) {
      d[i * 4] = out[i * 3];
      d[i * 4 + 1] = out[i * 3 + 1];
      d[i * 4 + 2] = out[i * 3 + 2];
      d[i * 4 + 3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    const res = { url: cv.toDataURL('image/png'), w: W / dpr, h: H / dpr };
    gemCache.set(key, res);
    return res;
  }
  function paintGems(el, crystal, pitchCss) {
    const tex = getGemTexture(crystal, pitchCss);
    if (!tex) {
      el.style.backgroundImage = `linear-gradient(145deg, ${crystal.tone.light}, ${crystal.tone.base} 55%, ${crystal.tone.dark})`;
      el.style.backgroundSize = '100% 100%';
      return;
    }
    el.style.backgroundImage = `url("${tex.url}")`;
    el.style.backgroundSize = `${tex.w}px ${tex.h}px`;
    el.style.backgroundRepeat = 'repeat';
    el.style.backgroundPosition = '0 0';
  }
  // Letter outline that keeps text readable on a bag of a similar colour: a dark
  // edge on light stones, a light edge on dark stones.
  function gemEdge(crystal) {
    const L = lumOf(hexToRgb(photoToneOf(crystal).hex));
    return L < 110
      ? 'drop-shadow(0 0 0.7px rgba(255,255,255,0.7)) drop-shadow(0 1px 1.2px rgba(0,0,0,0.45))'
      : 'drop-shadow(0 0 0.6px rgba(35,22,8,0.75)) drop-shadow(0 1px 1.4px rgba(0,0,0,0.45))';
  }

  function esc(t) {
    return String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  /* ----------------------------------------------------------- state ---- */
  // Optional: preselect a specific option (e.g. a team) without changing the tile order.
  const DEFAULT_BAG_NAME = (root.dataset.bespokeDefaultBag || '').trim().toLowerCase();
  const DEFAULT_BAG = (DEFAULT_BAG_NAME && BAGS.find((b) => String(b.value).toLowerCase() === DEFAULT_BAG_NAME)) || BAGS[0];
  const state = {
    bag: DEFAULT_BAG,
    style: styleById('block'),
    crystal: CRYSTALS[0],
    hardware: hardwareById('silver'),
    text: '',
    lines: LABEL_LINES.map(() => ''),
    addonOn: NOTE && !PAID_NOTE,
    stepKey: 'bag',
    view: 0, // 0 = front photo, 1 = back photo (products with a second view)
    mode: 'text', // 'text' | 'upload'
    sig: null, // { file, name, aspect, masks: [fine, standard, bold] data URLs }
    weight: 1,
    qty: 1,
    saved: false,
  };

  // Products that lock the lettering (e.g. a gift tag) skip those pickers.
  if (FIXED_STYLE) {
    state.style = styleById(FIXED_STYLE);
    root.querySelectorAll('[data-lv-bespoke-style-group]').forEach((el) => (el.hidden = true));
  }
  if (FIXED_CRYSTAL) {
    state.crystal = crystalById(FIXED_CRYSTAL);
    root.querySelectorAll('[data-lv-bespoke-crystal-group]').forEach((el) => (el.hidden = true));
  }
  // Some products (Gift Box) have hardware as a real variant, so the chosen
  // hardware decides which variant goes in the cart.
  function currentVariantId() {
    return state.hardware.id === 'champagne' && state.bag.variantIdChampagne
      ? state.bag.variantIdChampagne
      : state.bag.variantId;
  }

  // A swatch can bundle its hardware (Gift Box: "Jet with Silver Bow").
  function applyImpliedHardware() {
    if (state.bag.impliesHardware) state.hardware = hardwareById(state.bag.impliesHardware);
  }
  applyImpliedHardware();

  function availableCrystals() {
    if (FIXED_CRYSTAL) return [state.crystal];
    const allowed = state.bag.allowed;
    const pool = CRYSTALS.filter((c) => !c.fixedOnly);
    // Same order as the colour list configured for the bag (the live site's order).
    const list = allowed.length ? allowed.map((id) => pool.find((c) => c.id === id)).filter(Boolean) : pool;
    return list.length ? list : pool;
  }
  function ensureCrystalAllowed() {
    if (!availableCrystals().includes(state.crystal)) state.crystal = availableCrystals()[0];
  }
  // The bag and the text box show the lettering with the style's case rule (Block = all caps,
  // Signature/Cursive = first letter of each word capitalized), so show and save it the same
  // way: what the customer sees on the bag is exactly what goes into the header, the review
  // and the order.
  function displayText() {
    if (NOTE) return state.text.trim();
    if (state.style.transform === 'uppercase') return state.text.toUpperCase();
    if (state.style.transform === 'capitalize') return state.text.replace(/(^|\s)(\S)/g, (_, a, b) => a + b.toUpperCase());
    return state.text;
  }
  function usingSignature() {
    return ALLOW_UPLOAD && state.mode === 'upload';
  }
  // Dates are typed as month.day.year with 1-2 digit month/day and a 2-4 digit year
  // (3.29.93, 03.9.1993, 11.26.1990): no leading zeros required.
  const DATE_RE = /^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/;
  function dateValid(v) {
    const m = DATE_RE.exec(v);
    return !!m && +m[1] >= 1 && +m[1] <= 12 && +m[2] >= 1 && +m[2] <= 31;
  }
  function formatDateInput(raw, allowAutoDot) {
    const parts = [];
    let cur = '';
    let trailingDot = false;
    for (const ch of raw) {
      if (/\d/.test(ch)) {
        if (cur.length === (parts.length < 2 ? 2 : 4)) {
          if (parts.length >= 2) continue;
          parts.push(cur);
          cur = '';
        }
        cur += ch;
        trailingDot = false;
      } else if (/[.\/\-\s,]/.test(ch) && cur && parts.length < 2) {
        parts.push(cur);
        cur = '';
        trailingDot = true;
      }
    }
    let out = parts.concat(cur ? [cur] : []).join('.');
    if (trailingDot) out += '.';
    else if (allowAutoDot && parts.length < 2 && cur.length === 2) out += '.';
    return out;
  }
  const dateLinesValid = () => LABEL_LINES.every((l, i) => l.mask !== 'date' || !state.lines[i] || dateValid(state.lines[i]));
  function labelText(i) {
    const v = (state.lines[i] || '').trim();
    return LABEL_LINES[i].upper ? v.toUpperCase() : v;
  }
  function labelFilled() {
    return LABEL_LINES.map((l, i) => [l, labelText(i)]).filter(([, t]) => t);
  }
  const fmtMoney = (n) => `$${Number(n).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
  function addonActive() {
    if (!ADDON || !state.addonOn) return false;
    return CUSTOM && usingSignature() ? !!state.sig : state.text.trim().length > 0;
  }
  // Does the preview draw the customer's text/signature on the photo right now?
  // On Review the customer can flip between the team ball (front) and the customization (back).
  const drawsOnPhoto = () =>
    !ADDON || (CUSTOM && state.addonOn && (state.stepKey === 'monogram' || (state.stepKey === 'review' && state.view === 1)));
  function priceText() {
    if (!ADDON) return BASE_PRICE_TEXT;
    return fmtMoney((state.bag.price || Number(String(BASE_PRICE_TEXT).replace(/[^0-9.]/g, ''))) + (addonActive() ? ADDON_PRICE : 0));
  }
  function maxChars() {
    return ADDON ? ADDON_MAX : state.style.max;
  }
  function isComplete() {
    if (NO_TEXT) return true;
    if (NOTE && !PAID_NOTE) return true;
    if (ADDON) return !state.addonOn || addonActive();
    if (LABEL) return labelFilled().length > 0 && dateLinesValid();
    return usingSignature() ? !!state.sig : state.text.trim().length > 0;
  }

  /* ---------------------------------------------------------- preview --- */
  let measureCtx = null;
  const ENGRAVE_SAFE = 0.96;

  class PreviewController {
    constructor(el) {
      this.el = el;
      this.img = el.querySelector('[data-lv-bespoke-preview-img]');
      this.engrave = el.querySelector('[data-lv-bespoke-engrave]');
      this.mono = el.querySelector('[data-lv-bespoke-monogram]');
      this.glint = el.querySelector('[data-lv-bespoke-monogram-glint]');
      this.labelEls = null;
      if (LABEL) {
        const layer = document.createElement('div');
        layer.className = 'lv-bespoke__label-layer';
        layer.setAttribute('aria-hidden', 'true');
        this.labelEls = LABEL_LINES.map(() => {
          const span = document.createElement('span');
          span.className = 'lv-bespoke__label-line';
          span.style.color = LABEL_INK;
          layer.appendChild(span);
          return span;
        });
        el.appendChild(layer);
      }
      this.ro = new ResizeObserver(() => this.layout());
      this.ro.observe(el);
      this.img.addEventListener('load', () => this.layout());
    }
    render() {
      const src =
        CUSTOM && CUSTOM_IMG && drawsOnPhoto()
          ? CUSTOM_IMG
          : state.view === 1 && state.bag.images.back
            ? state.bag.images.back
            : state.bag.images.silver;
      if (this.img.getAttribute('src') !== src) {
        // Fade through the swap so changing bag/hardware doesn't flash.
        if (!reduceMotion && this.img.getAttribute('src')) {
          this.img.classList.add('is-swapping');
          const done = () => this.img.classList.remove('is-swapping');
          this.img.addEventListener('load', done, { once: true });
          window.setTimeout(done, 700);
        }
        this.img.setAttribute('src', src);
      }

      const upload = usingSignature();
      const draws = drawsOnPhoto();
      this.mono.textContent = upload || !draws ? '' : state.text;
      if (this.glint) this.glint.textContent = upload || !draws ? '' : state.text;
      this.mono.style.fontFamily = `"${state.style.font}", serif`;
      this.mono.style.letterSpacing = state.style.tracking;
      this.mono.style.textTransform = state.style.transform;
      if (this.glint) {
        this.glint.style.fontFamily = this.mono.style.fontFamily;
        this.glint.style.letterSpacing = this.mono.style.letterSpacing;
        this.glint.style.textTransform = this.mono.style.textTransform;
      }

      this.applyTexture();
      this.applySignatureMask();
      if (!this.maskActive) this.mono.style.filter = gemEdge(state.crystal);

      this.layout();
    }
    // An uploaded signature is shown as a mask over the same crystal fill the
    // text uses, so it reads as stones rather than a flat image.
    applySignatureMask() {
      const url = usingSignature() && state.sig && drawsOnPhoto() ? state.sig.masks[state.weight] : '';
      [this.mono, this.glint].forEach((el) => {
        if (!el) return;
        const st = el.style;
        if (url) {
          st.webkitMaskImage = st.maskImage = `url("${url}")`;
          st.webkitMaskRepeat = st.maskRepeat = 'no-repeat';
          st.webkitMaskPosition = st.maskPosition = 'center';
          st.webkitMaskSize = st.maskSize = 'contain';
          st.webkitBackgroundClip = st.backgroundClip = 'border-box';
          st.padding = '0';
          st.filter = 'none';
        } else {
          st.webkitMaskImage = st.maskImage = '';
          st.webkitBackgroundClip = st.backgroundClip = '';
          st.padding = '';
          st.width = '';
          st.height = '';
          st.filter = '';
        }
      });
      this.maskActive = !!url;
    }
    // Stone size is tied to the bag photo's own stone pitch (a share of the photo
    // width), so letters read as the same size of stones as the bag whether the
    // word is 2 letters or 9, and at any screen size.
    applyTexture() {
      paintGems(this.mono, state.crystal, STONE_PITCH * (this.imgW || 560));
    }
    // Printed label lines: each is fitted to its own small zone (cap-height
    // limited, shrinking to width for long text) and centered on its spot.
    layoutLabel(left, top, w, h) {
      if (!this.labelEls) return;
      measureCtx = measureCtx || document.createElement('canvas').getContext('2d');
      if (!measureCtx) return;
      const REF = 100;
      const labelStyleId = LABEL_STYLE_ID;
      const st = labelStyleId ? styleById(labelStyleId) : null;
      const crystal = LABEL_CRYSTAL_ID ? crystalById(LABEL_CRYSTAL_ID) : null;
      const TRACK = st ? parseFloat(st.tracking) || 0 : 0.04;
      LABEL_LINES.forEach((line, i) => {
        const el = this.labelEls[i];
        const text = labelText(i);
        el.textContent = text;
        if (!text || line.noDraw || line.view !== state.view) {
          el.style.display = 'none';
          return;
        }
        el.style.display = 'block';
        el.style.fontFamily = st ? `"${st.font}", serif` : '';
        el.style.fontWeight = st ? '400' : '';
        el.style.letterSpacing = st ? st.tracking : '';
        el.classList.toggle('is-crystal', !!crystal);
        if (crystal) {
          el.style.color = 'transparent';
          paintGems(el, crystal, STONE_PITCH * w);
          el.style.filter = gemEdge(crystal);
        } else {
          el.style.color = LABEL_INK;
          el.style.backgroundImage = '';
        }
        const cs = getComputedStyle(el);
        measureCtx.font = `${cs.fontWeight} ${REF}px ${cs.fontFamily}`;
        const m = measureCtx.measureText(text);
        const gaps = Math.max(0, Array.from(text).length - 1);
        const inkL = m.actualBoundingBoxLeft || 0;
        const inkR = (m.actualBoundingBoxRight || 0) + TRACK * REF * gaps;
        const inkW = inkL + inkR;
        // 'HO' (not 'HOJ'): the J of swashy script fonts drops far below the baseline and would shrink the whole line.
        const ref = measureCtx.measureText('HO');
        const asc = ref.actualBoundingBoxAscent || 0;
        const desc = ref.actualBoundingBoxDescent || 0;
        const capH = asc + desc;
        if (inkW <= 0 || capH <= 0) return;
        const fit = Math.min(line.w * w * ENGRAVE_SAFE / inkW, line.h * h / capH);
        const adv = m.width + TRACK * REF * Array.from(text).length;
        const fa = m.fontBoundingBoxAscent;
        const fd = m.fontBoundingBoxDescent;
        const dx = (adv / 2 - (inkR - inkL) / 2) * fit;
        const dy = (fa != null && fd != null ? (fd - fa - (desc - asc)) / 2 : 0) * fit;
        Object.assign(el.style, {
          left: `${left + line.x * w}px`,
          top: `${top + line.y * h}px`,
          fontSize: `${REF * fit}px`,
          transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px))${line.rot ? ` rotate(${line.rot}deg)` : ''}`,
        });
      });
    }
    layout() {
      if (this.el.offsetParent === null) return;
      const cw = this.el.clientWidth;
      const ch = this.el.clientHeight;
      const nw = this.img.naturalWidth;
      const nh = this.img.naturalHeight;
      if (!cw || !ch || !nw || !nh) return;

      const scale = Math.min(cw / nw, ch / nh);
      const w = nw * scale;
      const h = nh * scale;
      const top = (ch - h) / 2;
      const left = (cw - w) / 2;
      const zone = state.bag.engrave;
      if (this.imgW !== w) {
        this.imgW = w;
        this.applyTexture();
      }

      Object.assign(this.engrave.style, {
        left: `${left + (zone.x - zone.w / 2) * w}px`,
        top: `${top + (zone.y - zone.h / 2) * h}px`,
        width: `${zone.w * w}px`,
        height: `${zone.h * h}px`,
        transform: zone.rot ? `rotate(${zone.rot}deg)` : '',
      });

      if (LABEL) {
        this.layoutLabel(left, top, w, h);
        return;
      }
      const zoneW = zone.w * w * ENGRAVE_SAFE;
      const zoneH = zone.h * h * ENGRAVE_SAFE;

      if (this.maskActive) {
        // Signature: the mask is cropped to its ink, so "contain" gives the
        // same rule as text — fill the zone height, or shrink to its width.
        [this.mono, this.glint].forEach((el) => {
          if (!el) return;
          el.style.width = `${zoneW}px`;
          el.style.height = `${zoneH}px`;
          el.style.transform = el === this.glint ? 'translate(-50%, -50%)' : 'none';
        });
        return;
      }
      if (!state.text || usingSignature() || !drawsOnPhoto()) return;

      // Measure the real ink (not the CSS box) at a fixed reference size, then
      // scale linearly. Rules (from the design spec):
      //  - short text grows until it hits the zone's HEIGHT, longer text then
      //    shrinks until it hits the zone's WIDTH — always the larger of the two
      //    that still fits;
      //  - for Block, height is judged against a cap-height reference so every
      //    height-limited string lands on the same font-size;
      //  - the ink itself is centered on the zone, not the text box — script
      //    fonts have side bearings/overhang/descenders that make the box center
      //    visibly different from where the letters sit.
      const REF = 100;
      this.mono.style.transform = 'none';
      this.mono.style.fontSize = `${REF}px`;
      if (this.glint) this.glint.style.fontSize = `${REF}px`;
      const cs = getComputedStyle(this.mono);
      measureCtx = measureCtx || document.createElement('canvas').getContext('2d');
      if (!measureCtx) return;
      measureCtx.font = `${cs.fontWeight} ${REF}px ${cs.fontFamily}`;

      const caseText = (t) =>
        cs.textTransform === 'uppercase'
          ? t.toUpperCase()
          : cs.textTransform === 'capitalize'
            ? t.replace(/(^|\s)(\S)/g, (_, a, b) => a + b.toUpperCase())
            : t;
      const spacing = parseFloat(cs.letterSpacing) || 0;
      const str = caseText(this.mono.textContent);
      const count = Array.from(str).length;
      const m = measureCtx.measureText(str);
      const inkL = m.actualBoundingBoxLeft || 0;
      const inkR = (m.actualBoundingBoxRight || 0) + spacing * Math.max(0, count - 1);
      const inkW = inkR + inkL;
      const asc = m.actualBoundingBoxAscent || 0;
      const desc = m.actualBoundingBoxDescent || 0;
      const inkH = asc + desc;
      // Block is all caps, so a fixed cap-height reference keeps every
      // height-limited string on the same font-size. Script fonts vary too much
      // by letter (swash capitals, descenders) for that to look right — a short
      // name would end up well short of the zone — so they use their own ink.
      let refH = 0;
      if (state.style.id === 'block') {
        const ref = measureCtx.measureText('HOJ');
        refH = (ref.actualBoundingBoxAscent || 0) + (ref.actualBoundingBoxDescent || 0);
      }
      const heightBasis = Math.max(inkH, refH);
      if (inkW <= 0 || heightBasis <= 0) return;

      // Optional rule (per product, Block lettering only): HOLD_CHARS-character text keeps the size
      // that (HOLD_CHARS-1)-character text gets (its first HOLD_CHARS-1
      // characters, same limits as usual); longer text shrinks from there in
      // proportion to how much wider it is. A cap keeps it on the bag.
      const inkOf = (text) => {
        const mm = measureCtx.measureText(text);
        const n = Array.from(text).length;
        return (mm.actualBoundingBoxLeft || 0) + (mm.actualBoundingBoxRight || 0) + spacing * Math.max(0, n - 1);
      };
      let fit = Math.min(zoneW / inkW, zoneH / heightBasis);
      if (HOLD_CHARS >= 2 && count >= HOLD_CHARS && state.style.id === 'block') {
        const chars = Array.from(str);
        const wBase = inkOf(chars.slice(0, HOLD_CHARS - 1).join(''));
        const wHold = inkOf(chars.slice(0, HOLD_CHARS).join(''));
        if (wBase > 0 && wHold > 0) {
          const fitBase = Math.min(zoneW / wBase, zoneH / heightBasis);
          fit = Math.min(fitBase * (wHold / inkW), (w * HOLD_CAP) / inkW);
        }
      }
      fit = Math.min(12, Math.max(0.05, fit));
      const size = REF * fit;

      // Shift so the ink center (not the box center) sits on the zone center.
      // The box is already flex-centered on the zone, so the correction is
      // just boxCenter - inkCenter on each axis (line-height cancels out).
      const adv = m.width + spacing * count;
      const fa = m.fontBoundingBoxAscent;
      const fd = m.fontBoundingBoxDescent;
      let dx = adv / 2 - (inkR - inkL) / 2;
      let dy = fa != null && fd != null ? (fd - fa - (desc - asc)) / 2 : 0;
      dx *= fit;
      dy *= fit;

      this.mono.style.fontSize = `${size}px`;
      this.mono.style.transform = `translate(${dx}px, ${dy}px)`;
      if (this.glint) {
        this.glint.style.fontSize = `${size}px`;
        this.glint.style.transform = `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px))`;
      }
    }
  }

  const previews = Array.from(root.querySelectorAll('[data-lv-bespoke-preview]')).map(
    (el) => new PreviewController(el)
  );
  function renderPreview() {
    previews.forEach((p) => p.render());
  }
  // Re-measure after webfonts finish loading/swapping (matches the spec's
  // multi-timer approach — canvas measurements taken before a font swap are
  // wrong, and there's no single reliable "this font is ready" signal).
  [60, 180, 400, 900, 1600].forEach((ms) => setTimeout(renderPreview, ms));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(renderPreview);

  /* ------------------------------------------------------- bag picker ---- */
  function renderBagPicker() {
    bagEls.forEach((el) => {
      const active = el.dataset.lvBespokeBag === state.bag.value;
      el.classList.toggle('is-selected', active);
      el.setAttribute('aria-pressed', String(active));
    });
    applyStepZoom();
  }
  bagEls.forEach((el) => {
    el.addEventListener('click', () => {
      state.bag = BAGS.find((b) => b.value === el.dataset.lvBespokeBag) || state.bag;
      applyImpliedHardware();
      ensureCrystalAllowed();
      renderBagPicker();
      renderCrystalPicker();
      if (typeof applyBagFilter === 'function') applyBagFilter();
      renderPreview();
      syncBuyForm();
      updateStepValues();
      updateFooter();
    });
  });

  /* --------------------------------------------------- style/crystal ---- */
  const stylesEl = root.querySelector('[data-lv-bespoke-styles]');
  const crystalsEl = root.querySelector('[data-lv-bespoke-crystals]');
  const crystalLabelEl = root.querySelector('[data-lv-bespoke-crystal-label]');

  if (stylesEl) {
    stylesEl.innerHTML = DATA.letterStyles
      .filter((s) => !s.fixedOnly || s.id === FIXED_STYLE)
      .map(
        (s) => `
        <button type="button" class="lv-bespoke-style" data-lv-bespoke-style="${s.id}">
          <span class="lv-bespoke-style__sample" style="font-family:'${s.font}',serif;">Aa</span>
          <span class="lv-bespoke-style__label">${s.label}</span>
        </button>`
      )
      .join('');
  }
  function renderStylePicker() {
    if (!stylesEl) return;
    stylesEl.querySelectorAll('[data-lv-bespoke-style]').forEach((btn) => {
      btn.classList.toggle('is-selected', btn.dataset.lvBespokeStyle === state.style.id);
    });
  }
  if (stylesEl) {
    stylesEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-lv-bespoke-style]');
      if (!btn) return;
      state.style = styleById(btn.dataset.lvBespokeStyle);
      state.text = state.text.slice(0, maxChars());
      renderStylePicker();
      renderMonogramField();
      renderPreview();
      syncBuyForm();
      updateStepValues();
    });
  }

  function renderCrystalPicker(sparkleId) {
    if (!crystalsEl) return;
    crystalsEl.innerHTML = availableCrystals()
      .map(
        (c) => `
        <button type="button" class="lv-bespoke-crystal${c.id === state.crystal.id ? ' is-selected' : ''}" data-lv-bespoke-crystal="${c.id}" aria-label="${c.label}" title="${c.label}">
          <span class="lv-bespoke-gem"><img src="${c.gem}" alt="" width="64" height="64" loading="lazy" decoding="async"></span>
          <span class="lv-bespoke-crystal__label">${c.label}</span>
        </button>`
      )
      .join('');
    if (crystalLabelEl) crystalLabelEl.textContent = state.crystal.label;
    if (sparkleId && !reduceMotion) {
      const picked = crystalsEl.querySelector(`[data-lv-bespoke-crystal="${sparkleId}"]`);
      if (picked) picked.classList.add('is-sparkling');
    }
  }
  if (crystalsEl) {
    crystalsEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-lv-bespoke-crystal]');
      if (!btn) return;
      state.crystal = crystalById(btn.dataset.lvBespokeCrystal);
      renderCrystalPicker(state.crystal.id);
      renderPreview();
      syncBuyForm();
      updateStepValues();
    });
  }

  /* ------------------------------------------------------- monogram ----- */
  const fieldInput = root.querySelector('[data-lv-bespoke-input]');
  const fieldCount = root.querySelector('[data-lv-bespoke-count]');
  const fieldHint = root.querySelector('[data-lv-bespoke-field-hint]');
  const fieldWrap = root.querySelector('[data-lv-bespoke-field]');

  function renderMonogramField() {
    if (!fieldInput) return;
    fieldInput.value = state.text;
    fieldInput.maxLength = maxChars();
    if (!NOTE) {
      fieldInput.style.fontFamily = `"${state.style.font}", serif`;
      fieldInput.style.letterSpacing = state.style.tracking;
      fieldInput.style.textTransform = state.style.transform;
    }
    if (fieldCount) fieldCount.textContent = `${state.text.length}/${maxChars()}`;
    // Gray example text only: it is a placeholder, never part of the value, preview or order.
    if (!NOTE) fieldInput.placeholder = PLACEHOLDER_OVERRIDE || (state.style.id === 'block' ? 'JLC' : 'Judith');
    if (fieldHint) fieldHint.textContent = `Up to ${state.style.max} characters · ${state.style.label} lettering`;
  }
  if (fieldInput) {
    fieldInput.addEventListener('input', () => {
      state.text = fieldInput.value.slice(0, maxChars());
      if (fieldInput.value !== state.text) fieldInput.value = state.text;
      renderMonogramField();
      renderAddonUi();
      renderPreview();
      syncBuyForm();
      updateStepValues();
      updateFooter();
    });
    fieldInput.addEventListener('focus', () => {
      fieldWrap && fieldWrap.classList.add('is-focused');
      fieldInput.select();
    });
    fieldInput.addEventListener('blur', () => fieldWrap && fieldWrap.classList.remove('is-focused'));
  }
  root.querySelectorAll('[data-lv-bespoke-focus-input]').forEach((btn) => {
    btn.addEventListener('click', () => {
      fieldInput.focus();
      fieldInput.select();
    });
  });

  /* -------------------------------------------------------- hardware ---- */
  const hardwareHasPhotos = !!(root.querySelector('[data-lv-bespoke-hardware][data-hw-silver]'));
  const HARDWARE_SUB = {
    silver: 'Silver-toned frame, clasp and chain, with a silver leather lining',
    champagne: 'Champagne-toned frame, clasp and chain, with a gold leather lining',
  };
  const hardwareEl = root.querySelector('[data-lv-bespoke-hardware]');
  if (hardwareEl) {
    hardwareEl.innerHTML = DATA.hardware
      .map(
        (h) => `
        <button type="button" class="lv-bespoke-hardware-opt${hardwareEl.dataset['hw' + cap(h.id)] ? ' has-photo' : ''}" data-lv-bespoke-hardware="${h.id}">
          ${
            hardwareEl.dataset['hw' + cap(h.id)]
              ? `<span class="lv-bespoke-hardware-opt__photo"><img src="${hardwareEl.dataset['hw' + cap(h.id)]}" alt="${h.label} hardware texture" loading="lazy" decoding="async"></span>`
              : `<span class="lv-bespoke-metal lv-bespoke-metal--${h.id}"></span>`
          }
          <span class="lv-bespoke-hardware-opt__text">
            <span class="lv-bespoke-hardware-opt__label">${h.label}</span>
            <span class="lv-bespoke-hardware-opt__sub">${HARDWARE_SUB[h.id] || 'Frame, clasp, chain and lining'}</span>
          </span>
        </button>`
      )
      .join('');
  }
  function renderHardwarePicker() {
    if (!hardwareEl) return;
    hardwareEl.querySelectorAll('[data-lv-bespoke-hardware]').forEach((btn) => {
      btn.classList.toggle('is-selected', btn.dataset.lvBespokeHardware === state.hardware.id);
    });
  }
  function cap(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  if (hardwareEl) {
    hardwareEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-lv-bespoke-hardware]');
      if (!btn) return;
      state.hardware = hardwareById(btn.dataset.lvBespokeHardware);
      renderHardwarePicker();
      renderPreview();
      syncBuyForm();
      updateStepValues();
    });
  }

  /* ------------------------------------------------ optional paid add-on -- */
  const addonBtns = Array.from(root.querySelectorAll('[data-lv-bespoke-addon]'));
  const addonTextFieldEls = Array.from(root.querySelectorAll('[data-lv-bespoke-text-field]'));
  const customWrapEl = root.querySelector('[data-lv-bespoke-custom-wrap]');
  const previewNoteEl = document.querySelector('[data-lv-bespoke-preview-note]');
  const initialsEl = root.querySelector('[data-lv-bespoke-initials]');
  const initialsTextEl = root.querySelector('[data-lv-bespoke-initials-text]');
  const bagSearch = root.querySelector('[data-lv-bespoke-bag-search]');
  function renderAddonUi() {
    if (!ADDON) return;
    addonBtns.forEach((btn) => {
      const on = (btn.dataset.lvBespokeAddon === 'on') === state.addonOn;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', String(on));
    });
    addonTextFieldEls.forEach((el) => (el.hidden = !state.addonOn));
    if (customWrapEl) customWrapEl.hidden = CUSTOM && !state.addonOn;
    applyStepZoom();
    if (previewNoteEl && CUSTOM) previewNoteEl.hidden = !drawsOnPhoto();
    if (initialsEl) initialsEl.hidden = !addonActive();
    if (initialsTextEl) {
      initialsTextEl.textContent = displayText();
      initialsTextEl.style.fontFamily = `"${state.style.font}", serif`;
      initialsTextEl.style.letterSpacing = state.style.tracking;
      paintGems(initialsTextEl, state.crystal, 4);
    }
  }
  if (ADDON) {
    addonBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        state.addonOn = btn.dataset.lvBespokeAddon === 'on';
        renderAddonUi();
        renderPreview();
        syncBuyForm();
        updateStepValues();
        updateFooter();
        if (state.addonOn && fieldInput) window.setTimeout(() => fieldInput.focus(), 120);
      })
    );
  }
  // Tile filtering: the search box, and (for grouped pickers like Color → Team)
  // the chosen group. Combinations that don't exist simply have no tile.
  const groupOpts = Array.from(root.querySelectorAll('[data-lv-bespoke-group-opt]'));
  // Combinations that don't exist (e.g. a team logo that is only made on the Brown ball) stay
  // visible in the other colour as greyed tiles that say which colour they come in; tapping one
  // switches to that colour with the team selected.
  const unavailEls = [];
  function selectBag(next) {
    if (!next) return;
    state.bag = next;
    applyImpliedHardware();
    ensureCrystalAllowed();
    renderBagPicker();
    renderCrystalPicker();
    applyBagFilter();
    renderPreview();
    syncBuyForm();
    updateStepValues();
    updateFooter();
  }
  if (GROUPED && bagEls.length) {
    const groups = [...new Set(BAGS.map((b) => b.group))];
    const labels = [];
    BAGS.forEach((b) => {
      if (!labels.includes(b.label)) labels.push(b.label);
    });
    const wrap = bagEls[0].parentElement;
    labels.forEach((label) => {
      groups.forEach((g) => {
        if (BAGS.some((b) => b.group === g && b.label === label)) return;
        const donors = BAGS.filter((b) => b.label === label);
        const donor = donors[0];
        const only = donors.map((b) => b.group).join(' / ');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lv-bespoke-bag is-unavailable';
        btn.dataset.lvBespokeGroup = g;
        btn.dataset.lvBespokeLabel = label;
        btn.dataset.lvBespokeUnavail = donor.group;
        btn.title = `${label} is only made on the ${only} ball`;
        const img = donor.el.querySelector('img');
        btn.innerHTML = `<span class="lv-bespoke-bag__media">${img ? img.outerHTML : ''}</span><span class="lv-bespoke-bag__label">${esc(label)}<span class="lv-bespoke-bag__only">${esc(only)} ball only</span></span>`;
        // keep the team order: before the first tile of this colour whose team comes later
        const idx = labels.indexOf(label);
        const before = Array.from(wrap.children).find(
          (el) => el.dataset.lvBespokeGroup === g && labels.indexOf(el.dataset.lvBespokeLabel) > idx
        );
        wrap.insertBefore(btn, before || null);
        unavailEls.push(btn);
        btn.addEventListener('click', () => {
          selectBag(BAGS.find((b) => b.group === donor.group && b.label === label));
        });
      });
    });
  }
  function applyBagFilter() {
    const q = bagSearch ? bagSearch.value.trim().toLowerCase() : '';
    unavailEls.forEach((el) => {
      const inGroup = el.dataset.lvBespokeGroup === state.bag.group;
      const matches = !q || el.dataset.lvBespokeLabel.toLowerCase().includes(q);
      el.hidden = !(inGroup && matches);
    });
    bagEls.forEach((el) => {
      const inGroup = !GROUPED || el.dataset.lvBespokeGroup === state.bag.group;
      const matches = !q || (el.dataset.lvBespokeLabel || el.dataset.lvBespokeBag).toLowerCase().includes(q);
      el.hidden = !(inGroup && matches);
    });
    groupOpts.forEach((btn) => {
      const on = btn.dataset.lvBespokeGroupOpt === state.bag.group;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', String(on));
    });
  }
  if (bagSearch) bagSearch.addEventListener('input', applyBagFilter);
  groupOpts.forEach((btn) =>
    btn.addEventListener('click', () => {
      const g = btn.dataset.lvBespokeGroupOpt;
      // Keep the same team in the new color when it exists, else the first one.
      const same = BAGS.find((b) => b.group === g && b.label === state.bag.label);
      selectBag(same || BAGS.find((b) => b.group === g));
    })
  );

  /* ------------------------------------------- front/back photo switch ---- */
  const viewBtns = Array.from(root.querySelectorAll('[data-lv-bespoke-view]'));
  const HAS_BACK = CUSTOM || BAGS.some((b) => b.images.back);
  const viewSwitchEl = root.querySelector('[data-lv-bespoke-viewswitch]');
  function setView(v) {
    if (!HAS_BACK) return;
    state.view = v === 1 ? 1 : 0;
    viewBtns.forEach((btn) => btn.classList.toggle('is-selected', Number(btn.dataset.lvBespokeView) === state.view));
    if (CUSTOM) renderAddonUi();
    renderPreview();
  }
  viewBtns.forEach((btn) => btn.addEventListener('click', () => setView(Number(btn.dataset.lvBespokeView))));

  /* ------------------------------------------------ printed label lines -- */
  const labelFieldsEl = root.querySelector('[data-lv-bespoke-label-fields]');
  const labelInputs = [];
  if (LABEL && labelFieldsEl) {
    labelFieldsEl.hidden = false;
    root.querySelectorAll('[data-lv-bespoke-text-field], [data-lv-bespoke-style-group], [data-lv-bespoke-crystal-group]').forEach((el) => (el.hidden = true));
    LABEL_LINES.forEach((line, i) => {
      const wrap = document.createElement('div');
      wrap.className = 'lv-bespoke-labelfield';
      wrap.innerHTML = `
        <div class="lv-bespoke-field__top">
          <span class="lv-eyebrow">${esc(line.label)}</span>
          <span class="lv-body-small lv-bespoke-field__count" data-count>0/${line.max}</span>
        </div>
        <div class="lv-bespoke-field">
          <input type="text" class="lv-bespoke-field__input lv-bespoke-field__input--label" maxlength="${line.max}" placeholder="${esc(line.placeholder)}" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" aria-label="${esc(line.label)}">
        </div>
        ${line.mask === 'date' ? '<p class="lv-body-small lv-bespoke-error" data-line-error role="alert" hidden>Please use month.day.year, like 3.29.93 or 11.26.1990.</p>' : ''}`;
      const input = wrap.querySelector('input');
      const count = wrap.querySelector('[data-count]');
      if (line.upper) input.style.textTransform = 'uppercase';
      const errEl = wrap.querySelector('[data-line-error]');
      if (line.mask === 'date') input.setAttribute('inputmode', 'decimal');
      input.addEventListener('input', (e) => {
        if (line.mask === 'date') {
          const formatted = formatDateInput(input.value, !(e && /^delete/.test(e.inputType || '')));
          if (input.value !== formatted) input.value = formatted;
          if (errEl) errEl.hidden = true;
        }
        state.lines[i] = input.value.slice(0, line.max);
        count.textContent = `${state.lines[i].length}/${line.max}`;
        renderPreview();
        syncBuyForm();
        updateStepValues();
        updateFooter();
      });
      input.addEventListener('focus', () => {
        wrap.querySelector('.lv-bespoke-field').classList.add('is-focused');
        setView(line.view);
      });
      input.addEventListener('blur', () => {
        wrap.querySelector('.lv-bespoke-field').classList.remove('is-focused');
        if (line.mask === 'date') {
          const v = input.value.replace(/\.$/, '');
          if (v !== input.value) {
            input.value = v;
            state.lines[i] = v;
          }
          if (errEl) errEl.hidden = !v || dateValid(v);
          renderPreview();
          syncBuyForm();
          updateFooter();
        }
      });
      labelInputs.push(input);
      labelFieldsEl.appendChild(wrap);
    });
  }
  if (NO_TEXT) {
    root
      .querySelectorAll('[data-lv-bespoke-text-field], [data-lv-bespoke-style-group], [data-lv-bespoke-crystal-group], [data-lv-bespoke-mode-group]')
      .forEach((el) => (el.hidden = true));
  }
  function resetLabelFields() {
    state.lines = LABEL_LINES.map(() => '');
    labelInputs.forEach((input, i) => {
      input.value = '';
      const count = input.closest('.lv-bespoke-labelfield').querySelector('[data-count]');
      if (count) count.textContent = `0/${LABEL_LINES[i].max}`;
    });
  }

  /* ------------------------------------------------- signature upload --- */
  // Turns a photo/scan of a signature into a clean ink mask: removes paper
  // and uneven lighting, crops to the ink, and (per "Stroke") thickens the
  // lines, because crystals can't follow hairline strokes. The original file
  // is what goes to the cart; this is the preview of how it will be set.
  const modeBtns = Array.from(root.querySelectorAll('[data-lv-bespoke-mode]'));
  const modePanels = Array.from(root.querySelectorAll('[data-lv-bespoke-mode-panel]'));
  const dropEl = root.querySelector('[data-lv-bespoke-drop]');
  const fileInput = root.querySelector('[data-lv-bespoke-file-input]');
  const dropTitleEl = root.querySelector('[data-lv-bespoke-drop-title]');
  const fileErrorEl = root.querySelector('[data-lv-bespoke-file-error]');
  const sigPanelEl = root.querySelector('[data-lv-bespoke-sig]');
  const sigNameEl = root.querySelector('[data-lv-bespoke-sig-name]');
  const sigClearBtn = root.querySelector('[data-lv-bespoke-sig-clear]');
  const weightBtns = Array.from(root.querySelectorAll('[data-lv-bespoke-weight]'));
  const filePropInput = root.querySelector('[data-lv-bespoke-file-prop]');
  const WEIGHT_LABELS = ['Fine', 'Standard', 'Bold'];
  const WEIGHT_RADIUS = [0, 0.004, 0.0075]; // fraction of the mask's long side
  const MAX_FILE_BYTES = 10 * 1024 * 1024;
  const MASK_LONG_SIDE = 760;

  function smoothstep(a, b, x) {
    const t = Math.min(1, Math.max(0, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }

  function inkMaskFromImage(img) {
    const scale = Math.min(1, 1000 / Math.max(img.naturalWidth, img.naturalHeight));
    const w = Math.max(1, Math.round(img.naturalWidth * scale));
    const h = Math.max(1, Math.round(img.naturalHeight * scale));
    const cv = document.createElement('canvas');
    cv.width = w;
    cv.height = h;
    const ctx = cv.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    const px = ctx.getImageData(0, 0, w, h).data;
    const n = w * h;

    // Transparent PNG signatures carry the ink in alpha; photos/scans in luma.
    let transparent = 0;
    for (let i = 3; i < px.length; i += 4) if (px[i] < 200) transparent++;
    const hasAlpha = transparent > n * 0.02;

    const luma = new Float32Array(n);
    let sum = 0;
    for (let i = 0, j = 0; j < n; i += 4, j++) {
      luma[j] = 0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2];
      sum += luma[j];
    }
    const invert = !hasAlpha && sum / n < 90; // light ink on a dark background

    // Illumination estimate (heavy blur) so shadows and gradients on a phone
    // photo don't read as ink.
    const sw = Math.max(1, Math.round(w / 12));
    const sh = Math.max(1, Math.round(h / 12));
    const small = document.createElement('canvas');
    small.width = sw;
    small.height = sh;
    const sctx = small.getContext('2d', { willReadFrequently: true });
    sctx.drawImage(cv, 0, 0, sw, sh);
    const big = document.createElement('canvas');
    big.width = w;
    big.height = h;
    const bctx = big.getContext('2d', { willReadFrequently: true });
    bctx.imageSmoothingEnabled = true;
    bctx.imageSmoothingQuality = 'high';
    bctx.drawImage(small, 0, 0, w, h);
    const bg = bctx.getImageData(0, 0, w, h).data;

    const strength = new Float32Array(n);
    for (let i = 0, j = 0; j < n; i += 4, j++) {
      if (hasAlpha) {
        strength[j] = px[i + 3] / 255;
        continue;
      }
      let l = luma[j];
      let b = 0.299 * bg[i] + 0.587 * bg[i + 1] + 0.114 * bg[i + 2];
      if (invert) {
        l = 255 - l;
        b = 255 - b;
      }
      const ratio = l / Math.max(b, 24);
      strength[j] = smoothstep(0.86, 0.5, ratio);
    }

    // Ink bounds, ignoring isolated specks.
    const rows = new Uint32Array(h);
    const cols = new Uint32Array(w);
    let total = 0;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (strength[y * w + x] > 0.5) {
          rows[y]++;
          cols[x]++;
          total++;
        }
      }
    }
    if (total < Math.max(60, n * 0.0006)) return null;
    const first = (arr, min) => arr.findIndex((v) => v >= min);
    const last = (arr, min) => {
      for (let i = arr.length - 1; i >= 0; i--) if (arr[i] >= min) return i;
      return -1;
    };
    const x0 = first(cols, 2);
    const x1 = last(cols, 2);
    const y0 = first(rows, 2);
    const y1 = last(rows, 2);
    if (x0 < 0 || y0 < 0 || x1 <= x0 || y1 <= y0) return null;

    const cw = x1 - x0 + 1;
    const ch = y1 - y0 + 1;
    const out = document.createElement('canvas');
    out.width = cw;
    out.height = ch;
    const octx = out.getContext('2d');
    const od = octx.createImageData(cw, ch);
    for (let y = 0; y < ch; y++) {
      for (let x = 0; x < cw; x++) {
        const a = strength[(y + y0) * w + (x + x0)];
        const k = (y * cw + x) * 4;
        od.data[k + 3] = Math.round(a * 255);
      }
    }
    octx.putImageData(od, 0, 0);
    return out;
  }

  // Thicken by stamping the mask around a small circle (works everywhere,
  // unlike canvas filters), padded so the outline can't be clipped.
  function weightedMask(mask, weight) {
    const long = Math.max(mask.width, mask.height);
    const k = MASK_LONG_SIDE / long;
    const bw = Math.max(1, Math.round(mask.width * Math.min(1, k)));
    const bh = Math.max(1, Math.round(mask.height * Math.min(1, k)));
    const r = Math.round(WEIGHT_RADIUS[weight] * Math.max(bw, bh));
    const pad = r + 2;
    const cv = document.createElement('canvas');
    cv.width = bw + pad * 2;
    cv.height = bh + pad * 2;
    const ctx = cv.getContext('2d');
    ctx.imageSmoothingQuality = 'high';
    if (r > 0) {
      const steps = 16;
      for (let i = 0; i < steps; i++) {
        const a = (i / steps) * Math.PI * 2;
        ctx.drawImage(mask, pad + Math.cos(a) * r, pad + Math.sin(a) * r, bw, bh);
      }
    }
    ctx.drawImage(mask, pad, pad, bw, bh);
    return { url: cv.toDataURL('image/png'), aspect: cv.width / cv.height };
  }

  function setFileError(msg) {
    if (!fileErrorEl) return;
    fileErrorEl.textContent = msg || '';
    fileErrorEl.hidden = !msg;
  }

  function renderSignatureUi() {
    if (!ALLOW_UPLOAD) return;
    modeBtns.forEach((btn) => {
      const on = btn.dataset.lvBespokeMode === state.mode;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-selected', String(on));
    });
    modePanels.forEach((panel) => {
      panel.hidden = panel.dataset.lvBespokeModePanel !== state.mode;
    });
    if (sigPanelEl) sigPanelEl.hidden = !state.sig;
    if (sigNameEl) sigNameEl.textContent = state.sig ? state.sig.name : '';
    if (dropTitleEl) dropTitleEl.textContent = state.sig ? 'Choose a different image' : 'Choose a photo of your signature';
    weightBtns.forEach((btn) => btn.classList.toggle('is-selected', Number(btn.dataset.lvBespokeWeight) === state.weight));
  }

  function afterSignatureChange() {
    renderSignatureUi();
    renderPreview();
    syncBuyForm();
    updateStepValues();
    updateFooter();
  }

  function loadSignature(file) {
    setFileError('');
    if (!file) return;
    if (!/^image\//.test(file.type)) {
      setFileError('That file isn’t an image. Please choose a JPG or PNG.');
      return;
    }
    if (file.size > MAX_FILE_BYTES) {
      setFileError('That image is over 10 MB. Please choose a smaller one.');
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      let mask = null;
      try {
        mask = inkMaskFromImage(img);
      } catch (e) {
        mask = null;
      }
      URL.revokeObjectURL(url);
      if (!mask) {
        setFileError('We couldn’t find a signature in that image. Try dark ink on plain white paper.');
        return;
      }
      const masks = WEIGHT_LABELS.map((_, i) => weightedMask(mask, i));
      state.sig = { file, name: file.name, aspect: masks[1].aspect, masks: masks.map((m) => m.url) };
      afterSignatureChange();
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      setFileError('We couldn’t read that image. Please use a JPG or PNG.');
    };
    img.src = url;
  }

  if (ALLOW_UPLOAD && UPLOAD_ONLY) {
    state.mode = 'upload';
    root.querySelectorAll('[data-lv-bespoke-mode-group]').forEach((el) => (el.hidden = true));
  }
  if (ALLOW_UPLOAD) {
    modeBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        state.mode = btn.dataset.lvBespokeMode;
        renderSignatureUi();
        renderPreview();
        syncBuyForm();
        updateStepValues();
        updateFooter();
        if (state.mode === 'text' && fieldInput) fieldInput.focus();
      })
    );
    if (fileInput) fileInput.addEventListener('change', () => loadSignature(fileInput.files && fileInput.files[0]));
    if (dropEl) {
      ['dragenter', 'dragover'].forEach((ev) =>
        dropEl.addEventListener(ev, (e) => {
          e.preventDefault();
          dropEl.classList.add('is-over');
        })
      );
      ['dragleave', 'drop'].forEach((ev) =>
        dropEl.addEventListener(ev, (e) => {
          e.preventDefault();
          dropEl.classList.remove('is-over');
        })
      );
      dropEl.addEventListener('drop', (e) => loadSignature(e.dataTransfer && e.dataTransfer.files[0]));
    }
    weightBtns.forEach((btn) =>
      btn.addEventListener('click', () => {
        state.weight = Number(btn.dataset.lvBespokeWeight);
        renderSignatureUi();
        renderPreview();
        syncBuyForm();
      })
    );
    if (sigClearBtn)
      sigClearBtn.addEventListener('click', () => {
        state.sig = null;
        if (fileInput) fileInput.value = '';
        setFileError('');
        afterSignatureChange();
      });
  }

  /* ------------------------------------------------------ buy form ------ */
  function syncBuyForm() {
    root.querySelectorAll('[data-lv-delivery-prop]').forEach((input) => {
      input.value = DELIVERY_TEXT;
      input.disabled = !DELIVERY_TEXT;
    });
    root.querySelectorAll('[data-lv-bespoke-prop]').forEach((input) => {
      const key = input.dataset.lvBespokeProp;
      const sig = usingSignature();
      if (LABEL) {
        input.value = '';
        input.disabled = true;
        return;
      }
      if (NO_TEXT) {
        input.value = '';
        input.disabled = true;
        return;
      }
      if (CUSTOM) {
        const on = addonActive();
        input.value = '';
        if (on) {
          if (key === 'addon') input.value = `Yes (+${fmtMoney(ADDON_PRICE)})`;
          if (key === 'lettering') input.value = sig ? 'Signature (uploaded)' : state.style.label;
          if (key === 'monogram') input.value = sig ? '' : displayText();
          if (key === 'crystal') input.value = state.crystal.label;
          if (key === 'stroke') input.value = sig && state.sig ? WEIGHT_LABELS[state.weight] : '';
        }
        input.disabled = !input.value;
        return;
      }
      if (ADDON) {
        input.value = '';
        if (key === 'monogram') input.value = addonActive() ? displayText() : '';
        if (key === 'addon' && (!NOTE || PAID_NOTE)) input.value = addonActive() ? `Yes (+${fmtMoney(ADDON_PRICE)})` : '';
        input.disabled = !input.value;
        return;
      }
      if (key === 'hardware') input.value = SOLO ? '' : state.hardware.label;
      if (key === 'lettering') input.value = sig ? 'Signature (uploaded)' : state.style.label;
      if (key === 'monogram') input.value = sig ? '' : displayText();
      if (key === 'crystal') input.value = SOLO && !SOLO_COLOR ? '' : state.crystal.label;
      if (key === 'stroke') input.value = sig && state.sig ? WEIGHT_LABELS[state.weight] : '';
      // Don't send empty properties (they'd show up as blank lines in the cart).
      input.disabled = !input.value;
    });
    // Printed-label lines become one cart property each.
    if (LABEL && buyForm) {
      LABEL_LINES.forEach((line, i) => {
        let input = buyForm.querySelector(`[data-lv-bespoke-line="${i}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${line.label}]`;
          input.dataset.lvBespokeLine = String(i);
          buyForm.appendChild(input);
        }
        input.value = labelText(i);
        input.disabled = !input.value;
      });
    }
    // The original upload rides along as a real file input inside the cart form.
    if (filePropInput) {
      try {
        if (usingSignature() && state.sig && (!ADDON || addonActive())) {
          const dt = new DataTransfer();
          dt.items.add(state.sig.file);
          filePropInput.files = dt.files;
        } else {
          filePropInput.value = '';
        }
      } catch (e) {
        /* very old browsers: the typed-text path still works */
      }
    }
    root.querySelectorAll('[data-lv-bespoke-variant-id]').forEach((input) => {
      input.value = currentVariantId();
    });
  }

  /* ------------------------------------------------------ modal shell --- */
  const modal = document.querySelector('[data-lv-bespoke-modal]');
  const openButtons = document.querySelectorAll('[data-lv-bespoke-open]');
  const closeButtons = modal ? modal.querySelectorAll('[data-lv-bespoke-close]') : [];
  const zoomTarget = modal ? modal.querySelector('[data-lv-bespoke-zoom-target]') : null;
  const railBars = modal ? Array.from(modal.querySelectorAll('[data-lv-bespoke-rail-bar]')) : [];
  const railButtons = modal ? Array.from(modal.querySelectorAll('[data-lv-bespoke-step-jump]')) : [];
  const stepEls = modal ? Array.from(modal.querySelectorAll('[data-lv-bespoke-step]')) : [];
  const stepTitleEl = modal ? modal.querySelector('[data-lv-bespoke-step-title]') : null;
  const stepValueEl = modal ? modal.querySelector('[data-lv-bespoke-step-value]') : null;
  const backBtn = modal ? modal.querySelector('[data-lv-bespoke-back]') : null;
  const continueBtn = modal ? modal.querySelector('[data-lv-bespoke-continue]') : null;
  const addBtn = modal ? modal.querySelector('[data-lv-bespoke-modal-add]') : null;
  const modalPriceEl = modal ? modal.querySelector('[data-lv-bespoke-modal-price]') : null;
  const sparklesEl = modal ? modal.querySelector('[data-lv-bespoke-sparkles]') : null;

  const COMBINE = root.dataset.bespokeCombineHardware === 'true' || ADDON;
  const STEP_KEYS = SOLO
    ? ['monogram', 'review']
    : COMBINE
      ? ['bag', 'monogram', 'review']
      : ['bag', 'monogram', 'hardware', 'review'];
  const railTitleText = (i) => {
    const el = railButtons[i] && railButtons[i].querySelector('.lv-bespoke-rail__title');
    return el ? el.textContent.trim() : '';
  };
  const STEP_TITLES = SOLO
    ? [railTitleText(0) || 'Personalize', 'Review your creation']
    : ADDON
      ? [railTitleText(0) || 'Team', railTitleText(1) || 'Initials', 'Review your creation']
      : COMBINE
      ? ['Color & Hardware', 'Monogram', 'Review your creation']
      : ['Bag Color', 'Monogram', 'Hardware', 'Review your creation'];
  const stepKey = () => STEP_KEYS[stepIndex];
  let stepIndex = 0;

  function stepValueFor(i) {
    const key = STEP_KEYS[i];
    if (key === 'bag' && ADDON) return state.bag.value;
    if (key === 'bag') return state.bag.impliesHardware ? state.bag.value : `${state.bag.value} · ${state.hardware.label}`;
    if (key === 'monogram') {
      if (NO_TEXT) return state.bag.group ? `${state.bag.group} · ${state.bag.label}` : state.bag.label;
      if (NOTE) return addonActive() ? (PAID_NOTE ? `Request added (+${fmtMoney(ADDON_PRICE)})` : 'Request added') : (PAID_NOTE ? 'No customization' : 'None');
      if (CUSTOM) return addonActive() ? `${usingSignature() ? 'Signature' : displayText()} (+${fmtMoney(ADDON_PRICE)})` : `No ${ADDON_NOUN.toLowerCase()}`;
      if (ADDON) return addonActive() ? `${displayText()} (+${fmtMoney(ADDON_PRICE)})` : 'No initials';
      if (LABEL) {
        const filled = labelFilled().map(([, t]) => t);
        return filled.length ? filled.join(' · ') : 'Not set';
      }
      if (usingSignature()) return state.sig ? 'Uploaded signature' : 'Not set';
      if (!state.text) return 'Not set';
      const shown = displayText();
      if (!SOLO) return `${shown} · ${state.style.label} · ${state.crystal.label}`;
      return [shown, SOLO_BAGS ? state.bag.value : '', SOLO_COLOR ? state.crystal.label : ''].filter(Boolean).join(' · ');
    }
    if (key === 'hardware') return state.hardware.label;
    return priceText();
  }
  function updateStepValues() {
    if (stepValueEl) stepValueEl.textContent = stepValueFor(stepIndex);
    railButtons.forEach((btn, i) => {
      const label = btn.querySelector('[data-lv-bespoke-rail-label]');
      if (label) label.setAttribute('aria-current', String(i === stepIndex));
    });
  }
  function updateFooter() {
    if (backBtn) backBtn.hidden = stepIndex === 0;
    const last = stepIndex === STEP_TITLES.length - 1;
    if (continueBtn) {
      continueBtn.hidden = last;
      const blocked = LABEL && !dateLinesValid();
      continueBtn.disabled = blocked;
      continueBtn.classList.toggle('is-disabled', blocked);
    }
    if (addBtn) {
      addBtn.hidden = !last;
      addBtn.disabled = last && !isComplete();
      addBtn.classList.toggle('is-disabled', last && !isComplete());
    }
    if (modalPriceEl) modalPriceEl.textContent = priceText();
  }
  function spawnSparkles() {
    if (!sparklesEl || reduceMotion) return;
    sparklesEl.innerHTML = '';
    const spots = [
      [36, 24, 20, 380],
      [64, 18, 13, 560],
      [52, 44, 17, 720],
      [27, 46, 11, 880],
      [71, 50, 19, 1000],
      [45, 12, 10, 1150],
    ];
    spots.forEach(([left, top, size, delay], i) => {
      const gradId = `bespoke-sparkle-grad-${i}`;
      const span = document.createElement('span');
      span.className = 'lv-bespoke-sparkle';
      span.style.left = `${left}%`;
      span.style.top = `${top}%`;
      span.style.width = `${size}px`;
      span.style.height = `${size}px`;
      span.style.animationDelay = `${delay}ms`;
      span.innerHTML = `<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><defs><radialGradient id="${gradId}" cx="50%" cy="50%" r="50%"><stop offset="0%" stop-color="#fffef8"/><stop offset="55%" stop-color="#f4e6bd"/><stop offset="100%" stop-color="#d9b96a" stop-opacity="0.9"/></radialGradient></defs><path d="M12 0c.7 6.5 5.5 11.3 12 12-6.5.7-11.3 5.5-12 12-.7-6.5-5.5-11.3-12-12C6.5 11.3 11.3 6.5 12 0Z" fill="url(#${gradId})"/></svg>`;
      sparklesEl.appendChild(span);
    });
  }
  // The product copy lists hardware generically ("Choice of Champagne/Silver…", "Silver toned…");
  // on the review step show the finish the customer actually chose.
  function patchSpecs() {
    const finish = state.hardware && state.hardware.label;
    const hasChoice = STEP_KEYS.includes('hardware') || !!state.bag.impliesHardware;
    modal.querySelectorAll('.lv-bespoke-card__specs li, .lv-bespoke-card__specs').forEach((el) => {
      if (el.tagName !== 'LI') return;
      if (el.dataset.origSpec === undefined) el.dataset.origSpec = el.textContent;
      const orig = el.dataset.origSpec;
      if (hasChoice && finish && /(champagne|silver|gold)[^.]{0,40}toned metal hardware|choice of [^.]{0,40}hardware/i.test(orig)) {
        el.textContent = `${finish}-toned metal hardware`;
      } else {
        el.textContent = orig;
      }
    });
  }
  // Restrained zoom per step: a little closer on the lettering step, eased back out everywhere else.
  const zoomWrap = modal ? modal.querySelector('.lv-bespoke-modal__preview-wrap') : null;
  function applyStepZoom() {
    if (!zoomWrap || !uiReady) return;
    let s = 1;
    let zx = 50;
    let zy = 50;
    const onText = stepKey() === 'monogram' && !NO_TEXT && !NOTE && (!ADDON || (CUSTOM && state.addonOn));
    if (onText && !reduceMotion) {
      const first = LABEL ? LABEL_LINES.find((l) => !l.noDraw) : null;
      const z = state.bag.engrave;
      zx = (first ? first.x : z.x) * 100;
      zy = (first ? first.y : z.y) * 100;
      s = window.matchMedia('(min-width: 1024px)').matches ? 1.12 : 1.08;
    }
    zoomWrap.style.setProperty('--zoom', String(s));
    zoomWrap.style.setProperty('--zx', `${zx}%`);
    zoomWrap.style.setProperty('--zy', `${zy}%`);
  }
  function goToStep(i) {
    stepIndex = Math.max(0, Math.min(STEP_TITLES.length - 1, i));
    stepEls.forEach((el) => {
      el.hidden = Number(el.dataset.lvBespokeStep) !== stepIndex;
    });
    const bodyEl = modal && modal.querySelector('[data-lv-bespoke-body]');
    if (bodyEl) bodyEl.scrollTop = 0;
    if (stepTitleEl) stepTitleEl.textContent = STEP_TITLES[stepIndex];
    railBars.forEach((bar, i2) => {
      bar.classList.toggle('is-done', i2 < stepIndex);
      bar.classList.toggle('is-active', i2 === stepIndex);
      const item = bar.closest('.lv-bespoke-rail__item');
      if (item) item.classList.toggle('is-active', i2 === stepIndex);
    });
    // With example photos on the hardware cards there's nothing to zoom in on:
    // the bag preview stays as the customer's bag.
    // The bag photo never changes with the hardware choice (the cards are texture swatches).
    applyStepZoom();
    const panel = modal.querySelector('[data-lv-bespoke-panel]');
    if (panel) panel.classList.toggle('is-revealing', stepKey() === 'review');
    // The team ball on the team step; the blank ball with the customer's text on the others.
    state.stepKey = stepKey();
    if (CUSTOM) {
      state.view = 0;
      viewBtns.forEach((btn) => btn.classList.toggle('is-selected', Number(btn.dataset.lvBespokeView) === 0));
      if (viewSwitchEl) viewSwitchEl.hidden = !(state.stepKey === 'review' && addonActive());
      renderAddonUi();
      renderPreview();
    }
    if (stepKey() === 'review') patchSpecs();
    updateStepValues();
    updateFooter();
    // Auto-focus the text box on desktop only: on phones it would pop the
    // keyboard over the preview and scroll the step.
    const canAutofocus = window.matchMedia('(min-width: 1024px)').matches;
    if (!canAutofocus) {
      /* no autofocus on touch-size screens */
    } else if (stepKey() === 'monogram' && LABEL && labelInputs[0]) {
      window.setTimeout(() => labelInputs[0].focus({ preventScroll: true }), 260);
    } else if (stepKey() === 'monogram' && fieldInput && !usingSignature()) {
      window.setTimeout(() => {
        fieldInput.focus({ preventScroll: true });
        fieldInput.select();
      }, 260);
    }
    if (stepKey() === 'review') {
      setView(0);
      renderReview();
      spawnSparkles();
    }
    renderPreview();
  }

  const reviewRowsEl = modal ? modal.querySelector('[data-lv-bespoke-review-rows]') : null;
  const reviewTotalEl = modal ? modal.querySelector('[data-lv-bespoke-review-total]') : null;
  function renderReview() {
    if (!reviewRowsEl) return;
    const sig = usingSignature();
    const rows = NO_TEXT
      ? [
          ...(state.bag.group ? [['Color', state.bag.group]] : []),
          [state.bag.group ? 'Team' : 'Option', state.bag.label],
        ]
      : ADDON
      ? [
          ['Team', state.bag.value],
          [NOTE ? 'Customization request' : ADDON_NOUN, addonActive() ? (usingSignature() ? `Signature: ${state.sig.name}` : displayText()) : 'None'],
          ...(addonActive() && (!NOTE || PAID_NOTE) ? [[`${ADDON_NOUN} add-on`, `+${fmtMoney(ADDON_PRICE)}`]] : []),
        ]
      : LABEL
      ? [...labelFilled().map(([l, t]) => [l.label, t])]
      : SOLO
      ? [
          ...(SOLO_BAGS ? [['Bag color', state.bag.value]] : []),
          ['Lettering', sig ? 'Signature (uploaded)' : state.style.label],
          sig ? ['Signature', state.sig ? state.sig.name : '—'] : ['Monogram', displayText() || '—'],
          ...(sig ? [['Stroke', WEIGHT_LABELS[state.weight]]] : []),
          ...(SOLO_COLOR && !sig ? [['Letter color', state.crystal.label]] : []),
        ]
      : [
          ['Bag color', state.bag.value],
          ['Hardware', state.hardware.label],
          ['Lettering', state.style.label],
          ['Monogram', displayText() || '—'],
          ['Letter color', state.crystal.label],
        ];
    reviewRowsEl.innerHTML = rows
      .map(([k, v]) => `<div class="lv-bespoke-card__row"><dt>${k}</dt><dd>${esc(v)}</dd></div>`)
      .join('');
    if (reviewTotalEl) reviewTotalEl.textContent = priceText();
  }

  railButtons.forEach((btn, i) => btn.addEventListener('click', () => goToStep(i)));
  if (backBtn) backBtn.addEventListener('click', () => goToStep(stepIndex - 1));
  if (continueBtn) continueBtn.addEventListener('click', () => goToStep(stepIndex + 1));

  let lastFocus = null;
  let closing = false;
  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    closing = false;
    modal.classList.remove('is-closing');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    goToStep(0);
    const panel = modal.querySelector('[data-lv-bespoke-panel]');
    if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.focus({ preventScroll: true });
    }
  }
  function finishClose() {
    modal.hidden = true;
    modal.classList.remove('is-closing');
    document.body.style.overflow = '';
    closing = false;
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
    }
  }
  function closeModal() {
    if (!modal || modal.hidden || closing) return;
    if (reduceMotion) {
      finishClose();
      return;
    }
    closing = true;
    modal.classList.add('is-closing');
    window.setTimeout(finishClose, 220);
  }
  // Keep Tab inside the dialog while it's open.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !modal || modal.hidden) return;
    const focusable = Array.from(
      modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter((el) => !el.disabled && !el.hidden && el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === modal.querySelector('[data-lv-bespoke-panel]'))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
  openButtons.forEach((btn) => btn.addEventListener('click', openModal));
  closeButtons.forEach((btn) => btn.addEventListener('click', closeModal));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  /* -------------------------------------------------------- add to cart - */
  const buyForm = root.querySelector('[data-lv-bespoke-buy] form');
  const summaryBlock = root.querySelector('[data-lv-bespoke-summary]');
  const clearBtn = root.querySelector('[data-lv-bespoke-clear]');
  const buyBlock = root.querySelector('[data-lv-bespoke-buy]');
  const gallerySwap = root.querySelector('[data-lv-bespoke-gallery]');
  const savedSwap = root.querySelector('[data-lv-bespoke-saved]');
  const ctaLabel = root.querySelector('[data-lv-bespoke-cta-label]');
  const stickyTitle = document.querySelector('[data-lv-bespoke-sticky-title]');
  const stickyCta = document.querySelector('[data-lv-bespoke-sticky-cta]');

  const DEFAULT_CTA = ctaLabel ? ctaLabel.textContent.trim() : 'Customize your bag';
  function setSaved(saved) {
    state.saved = saved;
    if (gallerySwap) gallerySwap.hidden = saved;
    if (savedSwap) savedSwap.hidden = !saved;
    if (summaryBlock) summaryBlock.hidden = !saved;
    if (clearBtn) clearBtn.hidden = !saved;
    if (buyBlock) buyBlock.hidden = !saved;
    if (ctaLabel) ctaLabel.textContent = saved ? 'Edit your customization' : DEFAULT_CTA;
    if (saved) {
      root.querySelectorAll('[data-lv-summary]').forEach((el) => {
        const key = el.dataset.lvSummary;
        let value = '';
        if (NO_TEXT) {
          if (key === 'bag') value = state.bag.group ? `${state.bag.group} · ${state.bag.label}` : state.bag.label;
          el.textContent = value;
          const nr = el.closest('div');
          if (nr) nr.hidden = !value;
          return;
        }
        if (ADDON) {
          if (key === 'bag') value = state.bag.value;
          if (key === 'addon') value = addonActive() ? (NOTE ? displayText() : `${usingSignature() ? 'Signature' : displayText()} (+${fmtMoney(ADDON_PRICE)})`) : 'None';
          el.textContent = value;
          const addonRow = el.closest('div');
          if (addonRow) addonRow.hidden = !value;
          return;
        }
        if (key === 'bag') value = SOLO && !SOLO_BAGS ? '' : state.bag.value;
        if (key === 'lettering' && LABEL) value = labelFilled().map(([, t]) => t).join(' / ');
        else if (key === 'lettering')
          value = usingSignature() ? `Signature — ${state.sig ? state.sig.name : ''}` : `${state.style.label} — ${displayText()}`;
        if (key === 'crystal') value = SOLO && !SOLO_COLOR ? '' : state.crystal.label;
        if (key === 'hardware') value = SOLO ? '' : state.hardware.label;
        el.textContent = value;
        const row = el.closest('div');
        if (row) row.hidden = !value;
      });
      renderPreview();
    }
  }
  if (addBtn) {
    addBtn.addEventListener('click', () => {
      if (!isComplete()) return;
      syncBuyForm();
      setSaved(true);
      closeModal();
      if (buyForm) buyForm.requestSubmit();
    });
  }
  // Paid add-on charged as its own cart line (a hidden product): added just before
  // the item itself, whichever button submits the form, and rolled back if the item fails.
  let addonLineKey = null;
  async function addAddonLine() {
    const qty = Number(buyForm.querySelector('[name="quantity"]')?.value) || 1;
    const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`.replace('.js.js', '.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(ADDON_VARIANT),
            quantity: qty,
            properties: {
              For: state.bag.value,
              [ADDON_NOUN]: usingSignature() ? 'Signature (uploaded with the item)' : displayText(),
            },
          },
        ],
      }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add the add-on');
    return data.items && data.items[0] ? data.items[0].key : null;
  }
  if (ADDON && ADDON_VARIANT && (!NOTE || PAID_NOTE) && buyForm) {
    let passthrough = false;
    document.addEventListener(
      'submit',
      (e) => {
        if (e.target !== buyForm || passthrough || !addonActive()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        addAddonLine()
          .then((key) => {
            addonLineKey = key;
            passthrough = true;
            buyForm.requestSubmit();
            passthrough = false;
          })
          .catch((err) => {
            console.error(err);
            const msg = buyForm.querySelector('.product-form__error-message');
            const wrap = buyForm.querySelector('.product-form__error-message-wrapper');
            if (msg && wrap) {
              msg.textContent = 'Sorry, we could not add the customization. Please try again.';
              wrap.removeAttribute('hidden');
            }
          });
      },
      true
    );
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartError, () => {
        if (!addonLineKey) return;
        const key = addonLineKey;
        addonLineKey = null;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).catch(() => {});
      });
    }
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      state.text = '';
      state.addonOn = NOTE && !PAID_NOTE;
      renderMonogramField();
      renderAddonUi();
      if (LABEL) resetLabelFields();
      state.sig = null;
      if (fileInput) fileInput.value = '';
      renderSignatureUi();
      renderMonogramField();
      renderPreview();
      syncBuyForm();
      setSaved(false);
    });
  }

  /* ------------------------------------------------------- qty stepper -- */
  // Description / Specifications / Shipping toggles (this page doesn't load the standard PDP script).
  document.querySelectorAll('[data-lv-accordion-item]').forEach((item) => {
    const trigger = item.querySelector('[data-lv-accordion-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      const icon = item.querySelector('[data-lv-accordion-icon]');
      if (icon) icon.textContent = open ? '−' : '+';
    });
  });

  root.querySelectorAll('[data-lv-qty]').forEach((qtyEl) => {
    const valueEl = qtyEl.querySelector('[data-lv-qty-value]');
    const input = qtyEl.parentElement.querySelector('[data-lv-qty-input]');
    qtyEl.querySelectorAll('[data-lv-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.qty = Math.max(1, state.qty + Number(btn.dataset.lvQtyStep));
        if (valueEl) valueEl.textContent = String(state.qty);
        if (input) input.value = String(state.qty);
      });
    });
  });

  /* ---------------------------------------------------------- sticky bar */
  const stickyEl = document.querySelector('[data-lv-bespoke-sticky]');
  const buyAnchor = root.querySelector('[data-pdp-bespoke-buy]');
  if (stickyEl) {
    // Show the sticky bar only when neither the main Customize button nor the (saved) buy block is on screen.
    const anchors = [root.querySelector('.lv-bespoke__customize-cta'), buyAnchor].filter(Boolean);
    const seen = new Map();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => seen.set(e.target, e.isIntersecting));
        stickyEl.classList.toggle('is-visible', !anchors.some((el) => seen.get(el)));
      },
      { rootMargin: '-72px 0px 0px 0px' }
    );
    anchors.forEach((el) => io.observe(el));
  }

  /* ------------------------------------------------------------ gallery - */
  const galleryMainImg = root.querySelector('[data-lv-bespoke-gallery-img]');
  const galleryThumbs = Array.from(root.querySelectorAll('[data-lv-bespoke-gallery-thumb]'));
  function showGalleryThumb(thumb) {
    if (!thumb || !galleryMainImg) return;
    galleryMainImg.setAttribute('src', thumb.dataset.lvBespokeGallerySrc);
    galleryThumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
  }
  galleryThumbs.forEach((thumb) => thumb.addEventListener('click', () => showGalleryThumb(thumb)));
  showGalleryThumb(galleryThumbs[0]);

  /* --------------------------------------------------------------- init - */
  renderCrystalPicker();
  renderStylePicker();
  renderHardwarePicker();
  renderMonogramField();
  renderSignatureUi();
  renderAddonUi();
  applyBagFilter();
  renderBagPicker();
  syncBuyForm();
  renderPreview();
  updateFooter();
  uiReady = true;
  window.addEventListener('resize', renderPreview);
})();
